import { render } from "./OrganicStructurePage.vue?vue&type=template&id=6395d457"
import script from "./OrganicStructurePage.vue?vue&type=script&lang=js"
export * from "./OrganicStructurePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__